import React, { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { CommandPalette } from "./CommandPalette";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { NAV_GROUPS } from "@/lib/navigation";
import { NavLink } from "react-router-dom";

export function AppShell({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="grain flex min-h-screen bg-background">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-72 overflow-y-auto p-0">
          <div className="p-4">
            {NAV_GROUPS.map((g) => (
              <div key={g.label} className="mb-4">
                <p className="px-2 pb-1 text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground/70">{g.label}</p>
                {g.items.map((item) => {
                  const Icon = item.icon;
                  return (
                    <NavLink key={item.key} to={item.path} end={item.path === "/"} onClick={() => setMobileOpen(false)}
                      className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-2 text-sm ${isActive ? "bg-primary/12 text-primary" : "text-muted-foreground"}`}>
                      <Icon size={20} weight="duotone" /> {item.label}
                    </NavLink>
                  );
                })}
              </div>
            ))}
          </div>
        </SheetContent>
      </Sheet>

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onMobileNav={() => setMobileOpen(true)} />
        <main className="relative z-10 flex-1 px-4 py-6 sm:px-6 lg:px-8">{children}</main>
      </div>

      <CommandPalette />
    </div>
  );
}
